module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iA1ym"))).then(() => parcelRequire('9Lwss'));